import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ahaApi from "../../app/services/aha-api";

const initialState = {
  value: {},
  loading: false,
};

export const acknowledgePartialOrder = createAsyncThunk(
  "statOrders/acknowledgePartialOrder",
  async (id, { rejectWithValue }) => {
    const response = await ahaApi.Account.acknowledgePartialUto(id)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const acknowledgePartialOrderSlice = createSlice({
  name: "acknowledgePartialOrder",
  initialState,
  reducers: {
    clearAcknowledgePartialResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(acknowledgePartialOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(acknowledgePartialOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(acknowledgePartialOrder.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const acknowledgePartialOrderResponse = (state) => state.acknowledgePartialOrderState.value;
export const acknowledgePartialOrderLoading = (state) => state.acknowledgePartialOrderState.loading;
export const { clearAcknowledgePartialResponse } = acknowledgePartialOrderSlice.actions;
export default acknowledgePartialOrderSlice.reducer;
